const triggerChangeOnInput = (element) => {
  const event = new Event('change');
  element.closest('form').dispatchEvent(event);
}

const isPrefillEnabled = () => {
  return typeof (window.fullstackacademy.getCookie('prevent-form-data-prefill')) === "undefined";
}

export const formsApi = {
  async getPrefillFormData(domain) {
    const body = JSON.stringify({
      domain,
    });
    try {
      const response = await fetch(`${sharedApiUrl}/get-forms-data.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: body,
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error)
    }
  },

  async storePrefillData(domain, data) {
    if (!isPrefillEnabled()) {
      return
    }

    const body = JSON.stringify({
      domain,
      data,
    });
    try {
      const response = await fetch(`${sharedApiUrl}/save-forms-data.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: body,
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
    }
  },
};

export const setPrefillFormData = (event) => {
  const dataFields = [
    ...event.form.querySelectorAll(".fsa__form-select"),
    ...event.form.querySelectorAll(".fsa__form-input"),
  ];

  //Check if array is not empty
  if (dataFields.length < 1) {
    return;
  }

  const formData = dataFields.reduce(
    (acc, cur) => ({...acc, [cur.name]: cur.value}),
    {}
  );
  formsApi.storePrefillData(window.location.host, formData);
};

function prefillFormData(formData) {
  const fieldsToFill = [
    "firstname",
    "lastname",
    "email",
    "phone",
    "postal_zip_code",
    "mobilephone",
    "zip",
    // "program_first_choice",
    // "course_preference",
  ];

  if (formData) {
    const dataFields = [
      ...document.querySelectorAll(".fsa__form-select"),
      ...document.querySelectorAll(".fsa__form-input"),
    ];

    const formDataFieldsArray = dataFields.filter((item) =>
      fieldsToFill.includes(item.name)
    );

    if (formDataFieldsArray) {
      formDataFieldsArray.forEach((item) => {
        switch (item.tagName) {
          case "SELECT":
            if (item.value == '') {
              const options = [...item.options];
              const findIndex = options.find(
                (option) => option.value == formData[item.name]
              );
              if (findIndex) {
                findIndex.selected = true;
                triggerChangeOnInput(item);
              }
            }
            break;

          case "INPUT":
            switch (item.type) {
              case "text":
              case "tel":
              case "email":
                if (item.name in formData) {
                  item.value = formData[item.name];
                  triggerChangeOnInput(item);
                }
                break;

              case "radio":
                if (item.name in formData) {
                  item.checked = true;
                  triggerChangeOnInput(item);
                }
                break;

              case "checkbox":
                if (item.name in formData) {
                  item.checked = true;
                  triggerChangeOnInput(item);
                }
                break;

              case 'select':
                if (item.name in formData && item.value == '') {
                  // pre-fill select if the option exists in it and is not disabled.
                  let optionExists = false
                  const allOptions = item.querySelectorAll('option')
                  Array.from(allOptions).forEach(function (option) {
                    if (option.value == formData[item.name] && !option.disabled) {
                      optionExists = true
                    }
                  })

                  if (optionExists) {
                    Array.from(allOptions).forEach(option => option.removeAttribute('selected'));
                    Array.from(allOptions).forEach(function (option) {
                      if (option.value == formData[item.name] && !option.disabled) {
                        element.value = formData[item.name]
                        option.setAttribute('selected', 'selected')
                      }
                    })
                  }
                  triggerChangeOnInput(item);
                }

              default:
                if (item.name in formData) {
                  item.value = formData[item.name];
                  triggerChangeOnInput(item);
                }
            }
            break;
          default:
            return;
        }
      });
    }
  }
}

export const initializeDataPrefill = async () => {
  // if prevent-form-data-prefill cookie exists, don't use data prefill. Used for cypress
  if (!isPrefillEnabled()) {
    console.log("Form data is disabled due to cookie");
    return
  }

  const data = await formsApi.getPrefillFormData(window.location.host)
  if (!data || !data.success) {
    return
  }

  prefillFormData(data.prefillData)
}

export const processOtpUrlParam = async () => {
  const urlParams = new URLSearchParams(window.location.search)
  const data = {
    forms_data_otp: urlParams.get('forms_data_otp')
  }
  if (data.forms_data_otp) {
    try {
      const response = await fetch(`/initialize-freeform-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(data),
      });
      const json = await response.json();
      return true;
    } catch (error) {
      throw new Error(error);
    }
  } else {
    return false
  }
}